import { initialize } from 'dynamic-import-polyfill'

initialize()
